export default __webpack_public_path__ + "static/media/who-we-are.0e3f7e03.jpg";